import { primitive, semantic, categoryColors } from "./color";
import { radius, space, elevation } from "./shape";
import { duration, easing } from "./motion";
import { fontStacks, typeScale } from "./typography";

/** 토큰 → CSS 변수. 화면 코드는 의미 토큰만 참조한다 (T1/T4). */
export function cssVariables(): string {
  const out: string[] = [];
  for (const [family, scale] of Object.entries(primitive)) {
    if (family === "status") {
      for (const [k, v] of Object.entries(scale)) out.push(`--color-${k}:${v}`);
    } else {
      /* CSS 변수 이름은 kebab-case 로 통일한다 — statusSurface 같은 키가 그대로 새어나가지 않게. */
      const f = family.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);
      for (const [k, v] of Object.entries(scale)) out.push(`--${f}-${k}:${v}`);
    }
  }
  for (const [k, v] of Object.entries(semantic)) out.push(`--${k.replace(".", "-")}:${v}`);
  for (const [code, c] of Object.entries(categoryColors)) {
    const k = code.toLowerCase().replace(/_/g, "-");
    out.push(`--cat-${k}-fg:${c.fg}`, `--cat-${k}-bg:${c.bg}`);
  }
  for (const [k, v] of Object.entries(radius)) out.push(`--r-${k}:${v === 999 ? "999px" : `${v}px`}`);
  for (const [k, v] of Object.entries(space)) out.push(`--s-${k}:${v}px`);
  for (const [k, v] of Object.entries(elevation)) out.push(`--e-${k}:${v}`);
  for (const [k, v] of Object.entries(duration)) out.push(`--m-${k}:${v}ms`);
  for (const [k, v] of Object.entries(easing)) out.push(`--ease-${k}:${v}`);
  out.push(`--font-sans:${fontStacks.sans}`, `--font-mono:${fontStacks.mono}`);
  for (const [k, t] of Object.entries(typeScale)) {
    const n = k.replace("/", "-");
    out.push(`--t-${n}-size:${t.size}px`, `--t-${n}-line:${t.line}px`, `--t-${n}-weight:${t.weight}`, `--t-${n}-tracking:${t.tracking}`);
  }
  return `:root{\n  ${out.join(";\n  ")};\n}`;
}
